/* eslint-disable */
/* eslint-disable no-console */
/* eslint-disable arrow-parens */
/* eslint-disable max-classes-per-file */
/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import { withRouter, Link } from 'react-router-dom';
import Authorization from '../../Helpers/Authorization';
import ReactDOM from 'react-dom';

import {
  AdminNavLinks,
  NavLinks,
  UAT_NavLinks,
  QA_NavLinks,
  SuperAdminNavLinks,
  getImageSrc,
} from '../../Helpers/Constants';
import Env from '../../Helpers/env';

const StyledSideNav = styled.div`
  position: fixed; /* Fixed Sidebar (stay in place on scroll and position relative to viewport) */
  height: calc(100% - 8rem);
  width: 8rem; /* Set the width of the sidebar */
  z-index: 4; /* Stay on top of everything */
  overflow-y: auto;
  background-color: #a70e13;
  top: 8rem;
  padding-top: 5rem;
  transition: 0.3s;
`;

class SideNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: NavLinks,
    };
  }

  componentDidMount() {
    const userRole = Authorization.getAuthUserRole();
    // const userId = Authorization.getAuthUserId();
    if (userRole === 'SUPERADMIN') {
      this.setState({ items: SuperAdminNavLinks });
    } else if (userRole === 'ROOTADMIN') {
      this.setState({ items: AdminNavLinks });
    } else {
      this.setState({
        items:
          Env.env.ENV === 'stage'
            ? QA_NavLinks
            : Env.env.ENV === 'pre-prod'
            ? UAT_NavLinks
            : NavLinks,
      });
    }
  }

  onItemClick = path => {
    // Navigate to the given path
    this.props.history.push(path);
  };

  render() {
    const { items } = this.state;
    // Use current location pathname for active check
    const currentPath = window.location.pathname;

    return (
      <StyledSideNav>
        {items.map(item => (
          <NavItem
            path={item.path}
            name={item.name}
            css={item.css}
            icon={item.icon}
            onItemClick={this.onItemClick}
            // Active if currentPath starts with item.path (handles sub-paths)
            active={
              currentPath === item.path ||
              currentPath.startsWith(`${item.path}/`)
            }
            key={item.key}
          />
        ))}
      </StyledSideNav>
    );
  }
}

const RouterSideNav = withRouter(SideNav);

const StyledNavItem = styled.div`
  height: 6.1rem;
  width: 6.4rem;
  text-align: center;
  line-height: 4rem;
  background: ${props => (props.active ? 'rgba(255, 255, 255, 0.2);' : '')};
  border-radius: ${props => (props.active ? '0.8rem' : '')};
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: 540px) and (max-width: 720px) and (orientation: landscape) {
    height: 4rem;
    padding-top: 1rem;
  }
`;

class NavItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      show: false,
    };
  }

  handleClick = () => {
    const { path, onItemClick } = this.props;
    onItemClick(path);
  };

  hoverFunction = name => {
    this.setState({ name, show: true });
  };

  mouseOut = () => {
    this.setState({ show: false });
  };

  render() {
    const { name, active } = this.props;

    return (
      <>
        <div className="d-flex wrapper-icon">
          <StyledNavItem active={active}>
            <Link
              to={this.props.path}
              className={this.props.css}
              onClick={this.handleClick}
            >
              <div
                className="navParent"
                onMouseLeave={this.mouseOut}
                onMouseEnter={e => {
                  const rect = e.target.getBoundingClientRect();
                  this.setState({
                    hoverTop: rect.top,
                  });
                  this.hoverFunction(this.props.name);
                }}
              >
                <img src={getImageSrc(name, active)} alt={this.props.name} />
              </div>
            </Link>
          </StyledNavItem>
          {this.state.show &&
            ReactDOM.createPortal(
              <div
                className="hover-bar"
                style={{ top: this.state.hoverTop, left: '8rem' }}
              >
                <p className="text-hover">{this.state.name}</p>
              </div>,
              document.body
            )}
        </div>
      </>
    );
  }
}

function SideBar() {
  return <RouterSideNav />;
}

export default SideBar;
